module.exports = __webpack_public_path__ + "static/img/stay-option-icon-table-tennis.14cf2c1e.svg";